import { Component, OnInit, OnDestroy } from '@angular/core';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthHttpClient } from '../../services/auth-http-service/auth-http.service';
import { LoggingService } from '../../services/logging-service/logging.service';
import { UserSessionService } from '../../services/user-session-service/user-session.service';

@Component({
  selector: 'app-portal-logout-view',
  templateUrl: './portal-logout-view.component.html',
  styleUrls: ['./portal-logout-view.component.css'],
})
export class PortalLogoutViewComponent implements OnInit {

  private redirectTimer;
  private timerSubscription: Subscription;
  private logoutSubscription: Subscription;

  constructor(private shellUpdateService: ShellUpdateService,
    private appConfigService: AppConfigService, private router: Router, 
    private authHttp: AuthHttpClient, private loggingService: LoggingService, private userSession:UserSessionService) { }

  ngOnInit() {

    // Send a shell update message
    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(
      this.appConfigService.ApplicationName, "Logout", "v" + this.appConfigService.Version, this.appConfigService.Copyright));

    // Show / Hide footer etc
    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, false, false, true));

    // Redirect after x number of seconds
    this.redirectTimer = Observable.timer(1000, 1000);

    // Redirect once the user has been logged out
    this.timerSubscription = this.redirectTimer.subscribe(tick => {

      // Log the user out
      this.logoutSubscription = this.authHttp.postLogout(this.appConfigService.AuthenticationLogoutUrl).subscribe(response => {
        this.loggingService.log('User logged out', this.appConfigService.LogToConsole);
        this.userSession.logout();
      },
        error => {
          this.loggingService.log('Error logging user out', this.appConfigService.LogToConsole);
          this.userSession.logout();
        });
    });

  }

  ngOnDestroy() {
    if (this.timerSubscription)
      this.timerSubscription.unsubscribe();

    if (this.logoutSubscription)
      this.logoutSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/portal-logout-view/portal-logout-view.component.ts